import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
import { UiComponent } from '@df/ui/ui.component';
import { NCmsTrustpilotWidget } from '../trustpilot-widget/cms-trustpilot-widget.component';
import { IProductDataV3 } from '@df/catalog/product/product';
import { TrustpilotWidgetComponent } from '@df/module-trustpilot/trustpilot-widget.component';
import { ProductConfiguration } from '@df/module-product-configuration/model/product-configuration';
import { CommonModule } from '@angular/common';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Product } from '../../catalog/product/product.decorator';

export const PRODUCT_TRUSTPILOT_WIDGET_CONTAINER_CLASS = 'product-trustpilot-widget-container';

@Component({
    selector: 'product-trustpilot-widget',
    standalone: true,
    imports: [TrustpilotWidgetComponent, CommonModule, TranslationModule],
    templateUrl: './product-trustpilot-widget.html',
    styles: [
        `
            .product-trustpilot-widget-container:not(:has(iframe)) {
                min-height: var(--trustpilot-slot-height, 140px);
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductTrustpilotWidgetComponent>({
    id: 'product-trustpilot-widget',
    name: 'Product Trustpilot Widget',
    tags: ['Trustpilot'],
    onDemandOnly: true,
    fields: NCmsTrustpilotWidget.getFields(['hideTrustpilot', 'trustpilotLabel', 'stars'])
})
export class ProductTrustpilotWidgetComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsTrustpilotWidget.IData;

    protected display = true;

    protected product?: Product<IProductDataV3>;

    protected containerClass = PRODUCT_TRUSTPILOT_WIDGET_CONTAINER_CLASS;

    protected sku?: string;

    private readonly productConfiguration = inject(ProductConfiguration);

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.productConfiguration) {
            this.subscriptions.add(
                this.productConfiguration.product$.subscribe(product => {
                    // Update the inputs in place rather than toggling `display`: tearing the
                    // widget down re-runs its ngAfterViewInit and reloads the Trustpilot
                    // iframe, which collapses and re-expands the slot on every product change.
                    this.product = product as Product<IProductDataV3>;
                    this.sku = this.product?.getTrustpilotSkus();
                    this.detectChanges();
                })
            );
        }
    }
}
